$(function() {
  var dir = 'left';
  if ($("html").attr('dir') == 'rtl') {
      dir = 'right';
  }
  var mySlidebars = new $.slidebars();
  $('.site-header__mobile-menu-btn').on('click', function() {
      console.log('Clicked element:', this);  // Logs the clicked element
      mySlidebars.slidebars.toggle(dir);
  });
});



$(window).on("scroll",scrollFunction);
scrollFunction();

function scrollFunction(){
  if($(window).scrollTop() > 50){
    if(! $("body").hasClass("scrolling")){
      $("body").addClass("scrolling");
    }
  } else {
      if($("body").hasClass("scrolling")){
        $("body").removeClass("scrolling");
      }
    }
}
